export default "__VITE_ASSET__B6GsA6xr__"